import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
function TablaProducto(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_09ProductosMap = props.productosMap
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos } = api
    const { inventario } = useSelector(state => state.inventarioInstalacion || {})
    const opcionesInventario = inventario?.todos || []
    const tieneInventario = opcionesInventario && opcionesInventario.length > 0
    const [loteInventario, setLoteInventario] = React.useState(null)
    const [errorVolumen, setErrorVolumen] = React.useState('')
    const maxLitros = loteInventario && loteInventario.litros !== undefined && loteInventario.litros !== null ? parseFloat(loteInventario.litros) : null

    const calcularLitrosTotales = (neto, uni, botellas) => {
        const cant = parseFloat(neto) || 0
        const num = parseFloat(botellas) || 0
        if (uni === 'mL') return (cant / 1000) * num
        if (uni === 'cL') return (cant / 100) * num
        if (uni === 'L') return cant * num
        return cant * num
    }

    // const { productosMap, handdleProductoMap } = props.MapProductos
    const [id, setId] = React.useState()
    const [contenidoalcoholico, setContenidoAlcoholico] = React.useState('')
    const [numeroanalisis, setNumeroAnalisis] = React.useState('')
    const [numerocertificado, setNumeroCertificado] = React.useState('')
    const [marca, setMarca] = React.useState('')
    const [numerolote, setNumeroLote] = React.useState('')
    const [contenidonetobotella, setContenidoNetoBotella] = React.useState('')
    const [numerobotellas, setNumeroBotellas] = React.useState('')
    const [unidad, setunidad] = React.useState('')
    const [numerocajas, setNumeroCajas] = React.useState('')
    const [tipoproducto, settipoproducto] = React.useState('Producto para venta')
    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const columns = [
        {
            field: 'marca', headerName: 'Marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 180,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.marca}`} arrow>
                        <label>{`${params.row.marca} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numeroanalisis', headerName: 'No. de analisis', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 125,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numeroanalisis}`} arrow>
                        <label>{`${params.row.numeroanalisis} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerocertificado}`} arrow>
                        <label>{`${params.row.numerocertificado} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.numerolote}`} arrow>
                        <label>{`${params.row.numerolote} `}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'contenidoalcoholico', headerName: 'Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 80, },
        { field: 'contenidonetobotella', headerName: 'Cont. net.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 100, },
        { field: 'unidad', headerName: 'ud.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 0, width: 30, },
        { field: 'numerobotellas', headerName: 'No. de botellas', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 125, },
        { field: 'numerocajas', headerName: 'No. de cajas', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 115, },

        {
            field: 'tipoproducto', headerName: 'Tipo producto', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 120,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipoproducto}`} arrow>
                        <label>{`${params.row.tipoproducto} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) => (

                <Fragment>
                    {fc_09ProductosMap?.length > 0 ? (
                        <Fragment>

                            {/* // <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button> */}
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                        </Fragment>)}
                </Fragment>

            )
        },
    ]
    const botonEliminar = async (params) => {
        handdleRemoveProductosPrev({ data: params.row })
    }

    const botonGuardar = async () => {
        if (tieneInventario && !loteInventario) {
            settexto('Debe seleccionar un lote de la lista de inventario disponible.')
            setvalidacion(true)
            return
        }
        if (maxLitros !== null) {
            const litrosTotales = calcularLitrosTotales(contenidonetobotella, unidad, numerobotellas)
            if (litrosTotales > maxLitros) {
                settexto(`El volumen total calculado (${litrosTotales.toFixed(2)} L) supera la cantidad disponible en el inventario (${maxLitros} L).`)
                setvalidacion(true)
                return
            }
        }
        if (contenidoalcoholico.toString().length > 0 && parseFloat(contenidoalcoholico) > 34 && parseFloat(contenidoalcoholico) < 56 && numeroanalisis.length > 0 && marca !== "0" &&
            marca !== "" && numerolote.length > 0 && contenidonetobotella.toString().length > 0 && unidad !== "0" && unidad !== "" && numerobotellas.toString().length > 0) {
            let dato = {
                id: id, contenidoalcoholico: contenidoalcoholico, numeroanalisis: numeroanalisis, numerocertificado: numerocertificado,
                marca: marca, numerolote: numerolote, contenidonetobotella: contenidonetobotella, numerobotellas: numerobotellas, numerocajas: numerocajas, unidad: unidad, tipoproducto: tipoproducto
            }
            handdleEditProductosPrev(dato)
            setMarca('')
            setContenidoAlcoholico('')
            setNumeroAnalisis('')
            setNumeroCertificado('')
            setNumeroLote('')
            setContenidoNetoBotella('')
            setNumeroBotellas('')
            setNumeroCajas('')
            setunidad("0")
            settipoproducto('Producto para venta')
            setLoteInventario(null)
            setErrorVolumen('')
            setEditar(false)
            setproductoMap([])
        } else {
            setvalidacion(true)
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setNumeroAnalisis(params.row.numeroanalisis)
        setNumeroCertificado(params.row.numerocertificado)
        setMarca(params.row.marca)
        setNumeroLote(params.row.numerolote)
        setContenidoNetoBotella(params.row.contenidonetobotella)
        setNumeroBotellas(params.row.numerobotellas)
        setNumeroCajas(params.row.numerocajas)
        setunidad(params.row.unidad)
        settipoproducto('Producto para venta')
        const match = opcionesInventario.find(opt => (opt.no_lote === params.row.numerolote || opt.no_tanque === params.row.numerolote))
        if (match) {
            setLoteInventario(match)
        } else {
            setLoteInventario(null)
        }
        setErrorVolumen('')
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(productos)
    React.useEffect(() => {
        setRows(productos)
    }, [productos])

    const botonAgregar = async () => {
        if (tieneInventario && !loteInventario) {
            settexto('Debe seleccionar un lote de la lista de inventario disponible.')
            setvalidacion(true)
            return
        }
        if (maxLitros !== null) {
            const litrosTotales = calcularLitrosTotales(contenidonetobotella, unidad, numerobotellas)
            if (litrosTotales > maxLitros) {
                settexto(`El volumen total calculado (${litrosTotales.toFixed(2)} L) supera la cantidad disponible en el inventario (${maxLitros} L).`)
                setvalidacion(true)
                return
            }
        }
        if (contenidoalcoholico.toString().length > 0 && parseFloat(contenidoalcoholico) > 34 && parseFloat(contenidoalcoholico) < 56 && numeroanalisis.length > 0 && marca !== "0" &&
            marca !== "" && numerolote.length > 0 && contenidonetobotella.toString().length > 0 && unidad !== "0" && unidad !== "" && numerobotellas.toString().length > 0) {
            let dato = {
                id: uuidv4(), contenidoalcoholico: contenidoalcoholico, numeroanalisis: numeroanalisis, numerocertificado: numerocertificado,
                marca: marca, numerolote: numerolote, contenidonetobotella: contenidonetobotella, numerobotellas: numerobotellas, numerocajas: numerocajas,
                unidad: unidad, tipoproducto: tipoproducto
            }
            handdleProducto(dato)
            setMarca('')
            setContenidoAlcoholico('')
            setNumeroAnalisis('')
            setNumeroCertificado('')
            setNumeroLote('')
            setContenidoNetoBotella('')
            setNumeroBotellas('')
            setNumeroCajas('')
            settipoproducto('Producto para venta')
            setunidad("0")
            setLoteInventario(null)
            setErrorVolumen('')
        } else {
            setvalidacion(true)
        }

    }
    const botonCancelar = async () => {
        // handdleProductoMap([])
        setproductoMap([])
        setContenidoAlcoholico('')
        setNumeroAnalisis('')
        setNumeroCertificado('')
        setMarca('')
        setNumeroLote('')
        setContenidoNetoBotella('')
        setNumeroBotellas('')
        setNumeroCajas('')
        settipoproducto('Producto para venta')
        setunidad("0")
        setLoteInventario(null)
        setErrorVolumen('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        // setproductoMap(props.MapProductos.productosMap[0])
        const filtro = fc_09ProductosMap.filter(anexo => anexo.idfc33_anexoproducto === params.row.idfc33_anexoproducto)
        setproductoMap(filtro[0])
        // handdleProductoMap(filtro[0])
        // setproductoMap([])
        if (params.row.idfc33_anexoproducto) setId(params.row.idfc33_anexoproducto)
        else setId(params.row.idfc33_anexoproducto)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setNumeroAnalisis(params.row.numeroanalisis)
        setNumeroCertificado(params.row.numerocertificado)
        setMarca(params.row.marca)
        setNumeroLote(params.row.numerolote)
        setContenidoNetoBotella(params.row.contenidonetobotella)
        setNumeroBotellas(params.row.numerobotellas)
        setNumeroCajas(params.row.numerocajas)
        setunidad(params.row.unidad)
        settipoproducto('Producto para venta')
        const match = opcionesInventario.find(opt => (opt.no_lote === params.row.numerolote || opt.no_tanque === params.row.numerolote))
        if (match) {
            setLoteInventario(match)
        } else {
            setLoteInventario(null)
        }
        setErrorVolumen('')
        setEditar(true)
    }

    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>
                    <div className='col-md-4'>
                        <div className="form-floating mb-2">
                            <input type="text" min='0' disabled={!!loteInventario} className={`form-control ${productoMap?.productocheck !== undefined ? (
                                productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                id="floatingInput" placeholder='Contenido Alcohólico'
                                value={contenidoalcoholico} onChange={e => {
                                    const inputValue = e.target.value;
                                    if (/^\d*\.?\d*$/.test(inputValue)) {
                                        setContenidoAlcoholico(inputValue);
                                    }
                                }}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <Tooltip title={`Contenido Alcohólico`} arrow>
                                <label htmlFor='floatingInput'>% Alc. Vol.</label>
                            </Tooltip>
                            {loteInventario && (
                                <small className="text-muted">Bloqueado según registro del lote en inventario</small>
                            )}
                            {contenidoalcoholico < 35 || contenidoalcoholico > 55 ?
                                <span className='text-danger'>El rango debe de ser de 35% a 55%</span> : ''
                            }<br />
                            {contenidoalcoholico.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-2">
                            <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (
                                productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                id="floatingInput" placeholder='No. de análisis de laboratorio'
                                value={numeroanalisis} onChange={e => setNumeroAnalisis(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>No. de análisis de laboratorio</label>
                            {numeroanalisis.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-2">
                            <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de certificado NOM'
                                value={numerocertificado} onChange={e => setNumeroCertificado(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>No. de certificado NOM vigente</label>
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <select className={`form-select ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={marca}
                                onChange={e => setMarca(e.target.value)}
                            >
                                <option value="0">Seleccione una opción</option>
                                {
                                    marcas?.map((opcion, i) => (
                                        // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                        <option value={`${opcion.marca}`} >{`${opcion.marca}`}</option>
                                        // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                    ))
                                }
                            </select>
                            {marca === "0" || marca === "" ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        {tieneInventario ? (
                            <div className="mb-3">
                                <Autocomplete
                                    options={opcionesInventario}
                                    getOptionLabel={(option) => {
                                        if (!option) return ''
                                        if (typeof option === 'string') return option
                                        return option.no_lote || option.no_tanque || ''
                                    }}
                                    isOptionEqualToValue={(option, val) => {
                                        if (!val) return false
                                        if (typeof val === 'string') return (option.no_lote === val || option.no_tanque === val)
                                        return (option.idinventario && val.idinventario && option.idinventario === val.idinventario) || (option.no_lote === val.no_lote)
                                    }}
                                    value={loteInventario}
                                    onChange={(event, newValue) => {
                                        if (newValue && typeof newValue === 'object') {
                                            const loteNum = newValue.no_lote || newValue.no_tanque || ''
                                            setNumeroLote(loteNum)
                                            setLoteInventario(newValue)
                                            if (newValue.clave_fq) {
                                                setNumeroAnalisis(newValue.clave_fq)
                                            }
                                            if (newValue.porcentaje_alc_vol !== undefined && newValue.porcentaje_alc_vol !== null) {
                                                setContenidoAlcoholico(String(newValue.porcentaje_alc_vol))
                                            }
                                            setErrorVolumen('')
                                        } else {
                                            setNumeroLote('')
                                            setLoteInventario(null)
                                            setErrorVolumen('')
                                        }
                                    }}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.idinventario || option.no_lote || Math.random()}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <strong>Lote: {option.no_lote || option.no_tanque || 'S/N'} ({option.tipo_inventario ? option.tipo_inventario.toUpperCase() : 'INVENTARIO'})</strong>
                                                <small style={{ color: '#666', fontSize: '0.75rem' }}>
                                                    FQ: {option.clave_fq || 'N/A'} | %Alc: {option.porcentaje_alc_vol || 'N/A'}% | Litros: {option.litros || 0}L
                                                </small>
                                            </div>
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Seleccionar lote del inventario"
                                            variant="outlined"
                                            placeholder="Seleccione un lote..."
                                            size="small"
                                            fullWidth
                                            className={productoMap?.productocheck !== undefined ? (productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ''}
                                        />
                                    )}
                                />
                                {!loteInventario && (
                                    <span className='text-danger'>Debe seleccionar un lote del inventario</span>
                                )}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        ) : (
                            <div className="form-floating mb-3">
                                <input
                                    type="text"
                                    className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ''}`}
                                    id="floatingInputLote"
                                    placeholder="No. de lote envasado"
                                    value={numerolote}
                                    onChange={e => {
                                        setNumeroLote(e.target.value)
                                        setLoteInventario(null)
                                    }}
                                />
                                <label htmlFor="floatingInputLote">No. de lote envasado</label>
                                {numerolote.length <= 0 && (
                                    <span className='text-danger'>Campo obligatorio</span>
                                )}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        )}
                    </div>
                    <div className='col-md-3'>
                        <div className="form-floating mb-3">
                            <input type="number" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                value={contenidonetobotella} onChange={e => {
                                    const val = e.target.valueAsNumber;
                                    setContenidoNetoBotella(val);
                                    if (maxLitros !== null) {
                                        const tot = calcularLitrosTotales(val, unidad, numerobotellas);
                                        if (tot > maxLitros) {
                                            setErrorVolumen(`El volumen total calculado (${tot.toFixed(2)} L) supera los ${maxLitros} L disponibles en inventario`);
                                        } else {
                                            setErrorVolumen('');
                                        }
                                    }
                                }}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <label htmlFor='floatingInput'>Contenido neto x botella</label>
                            {unidad === "mL" ? (
                                contenidonetobotella < 20 || contenidonetobotella > 5000 ?
                                    (<span className='text-danger'>El rango debe de ser de 20 ml a 5000 ml</span>) : ''
                            ) : unidad === 'L' ? (contenidonetobotella < .02 || contenidonetobotella > 5 ?
                                (<span className='text-danger'>El rango debe de ser de .02 L a 5 L</span>) : '') :
                                unidad === 'cL' ? (contenidonetobotella < 2 || contenidonetobotella > 500 ?
                                    (<span className='text-danger'>El rango debe de ser de 2 cl a 500 cl</span>) : '') : ''}
                            {contenidonetobotella.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>

                        </div>
                    </div>
                    <div className='col-md-1'>
                        <div className="form-floating mb-3">

                            <select onChange={e => {
                                const uni = e.target.value;
                                setunidad(uni);
                                if (maxLitros !== null) {
                                    const tot = calcularLitrosTotales(contenidonetobotella, uni, numerobotellas);
                                    if (tot > maxLitros) {
                                        setErrorVolumen(`El volumen total calculado (${tot.toFixed(2)} L) supera los ${maxLitros} L disponibles en inventario`);
                                    } else {
                                        setErrorVolumen('');
                                    }
                                }
                            }}
                                value={unidad}
                                className={`form-select form-select-sm ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`}
                            >
                                <option value="0" >Unidad</option>
                                <option value="mL">mL</option>
                                <option value="L">L</option>
                                <option value="cL">cL</option>
                            </select>
                            {unidad === "0" || unidad === "" ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <input type="number" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')} ${errorVolumen ? 'is-invalid' : ''}`} id="floatingInput" placeholder='No. de batellas'
                                value={numerobotellas} onChange={e => {
                                    const val = e.target.valueAsNumber;
                                    setNumeroBotellas(val);
                                    if (maxLitros !== null) {
                                        const tot = calcularLitrosTotales(contenidonetobotella, unidad, val);
                                        if (tot > maxLitros) {
                                            setErrorVolumen(`El volumen total calculado (${tot.toFixed(2)} L) supera los ${maxLitros} L disponibles en inventario`);
                                        } else {
                                            setErrorVolumen('');
                                        }
                                    }
                                }}
                                onWheel={event => event.currentTarget.blur()}
                            />
                            <label htmlFor='floatingInput'>No. de botellas</label>
                            {maxLitros !== null && (
                                <small className="text-muted">Disponible en inventario: {maxLitros} L (Calculado: {calcularLitrosTotales(contenidonetobotella, unidad, numerobotellas).toFixed(2)} L)</small>
                            )}
                            {errorVolumen && (
                                <div className="text-danger" style={{ fontSize: '0.85rem' }}>{errorVolumen}</div>
                            )}
                            {numerobotellas.toString().length < 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-floating mb-3">
                            <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={numerocajas} onChange={e => setNumeroCajas(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>No. de cajas</label>
                            {/* <br /> */}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    {emicioncertificadopromocion &&
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <select onChange={e => settipoproducto(e.target.value)}
                                    value={tipoproducto}
                                    className={`form-select form-select-sm ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                >
                                    {/* <option value="0" >Tipo de producto</option> */}
                                    <option value="Producto para venta">producto para venta</option>
                                    <option value="Promoción">Promoción</option>
                                </select>
                                <label htmlFor='floatingInput'>Tipo de producto</label>
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>}
                    {/* <hr /> */}
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_09ProductosMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar producto</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            {/* <div className='text-center'> */}
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar producto</button>
                            {/* </div> */}
                            {/* <div className='text-center'> */}
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                            {/* </div> */}

                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '104%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

        </>
    )

}
export default TablaProducto